/* Recommendations use only the supplied current product and exact variant data. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.MiniPowerFinderEngine = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function text(value) {
    if (value && typeof value === 'object' && 'value' in value) value = value.value;
    return value == null ? '' : String(value).trim();
  }
  function normalized(value) {
    return text(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ß/g, 'ss');
  }
  function brand(value) {
    var valueNormalized = normalized(value).replace(/[^a-z0-9]/g, '');
    return /^ankersolix$/.test(valueNormalized) ? 'anker' : valueNormalized;
  }
  function number(value, unit) {
    var raw = text(value).replace(/\s/g, '');
    if (raw.indexOf(',') !== -1) raw = raw.replace(/\./g, '').replace(',', '.');
    else if (unit !== 'kwh' && unit !== 'kw' && /^\d{1,3}(?:\.\d{3})+$/.test(raw)) raw = raw.replace(/\./g, '');
    var result = Number(raw);
    return Number.isFinite(result) && result >= 0 ? result : null;
  }
  function amounts(metric, dimension) {
    var matches = [], expression = dimension === 'energy' ? /(\d[\d.,\s]*?)\s*(kwh|wh)\b/gi : /(\d[\d.,\s]*?)\s*(kw|w)\b/gi;
    var source = normalized(metric), match;
    while ((match = expression.exec(source))) {
      var unit = match[2].toLowerCase(), value = number(match[1], unit);
      if (value === null) continue;
      var prefix = source.slice(0, match.index).match(/(\d+)\s*[x×]\s*$/);
      if (dimension === 'power' && prefix) value *= Number(prefix[1]);
      if (dimension === 'energy' && unit === 'wh') value /= 1000;
      if (dimension === 'power' && unit === 'kw') value *= 1000;
      matches.push(value);
    }
    return matches;
  }
  function panelCount(metric) {
    var source = normalized(metric), match = source.match(/\b(\d+)\s*[x×]\s*\d[\d.,]*\s*w(?:p)?\b/);
    if (!match) match = source.match(/\b\d[\d.,]*\s*w(?:p)?\s*[x×]\s*(\d+)\b/);
    if (!match) match = source.match(/\b(\d+)\s*(?:solar-?module?|pv-?module?|module?|panels?)\b/);
    return match ? Number(match[1]) : null;
  }
  function unique(values) { return Array.from(new Set(values)); }
  function locations(value) {
    var source = normalized(value), found = [];
    if (/balkon|gelander|brustung/.test(source)) found.push('balcony');
    if (/flachdach|flach\s*dach/.test(source)) found.push('flat');
    if (/ziegeldach|schragdach|steildach|trapez|pfannendach|dachhaken/.test(source)) found.push('roof');
    if (/wand|fassade/.test(source)) found.push('wall');
    if (/garten|boden|freiland/.test(source)) found.push('garden');
    return found;
  }

  function facts(product, variant) {
    product = product || {}; variant = variant || {};
    var title = normalized(product.title), type = normalized(product.type);
    var stats = Array.isArray(variant.stats) ? variant.stats : [];
    var optionNames = Array.isArray(product.options) ? product.options : [];
    var optionValues = Array.isArray(variant.options) ? variant.options : [];
    var capacities = [], pvPowers = [], mounts = [], panelCounts = [], coupling = [];
    var inverterIncluded = false, inverterExcluded = false, threePhase = false, hasPanelOption = false, serviceOnly = false;
    var lightweight = null, mountingUnspecified = false, mountingSpecified = false;
    var qty = typeof variant.panelQty === 'number' && Number.isInteger(variant.panelQty) && variant.panelQty >= 0 ? variant.panelQty : null;
    var role = normalized(variant.panelRole);

    function mount(value) {
      var source = normalized(value);
      if (!source) return;
      if (/^ohne$|\bohne\s+(?:halterung|montage|montageset|befestigung)\b|keine\s+halterung|no\s+mount/.test(source)) {
        mountingUnspecified = true;
      } else {
        mountingSpecified = true;
        mounts = mounts.concat(locations(source));
      }
    }
    stats.forEach(function (stat) {
      var label = normalized(stat.label), metric = normalized(stat.metric);
      if (/kapazitat|^speicher$|^battery capacity$/.test(label) && !/max|erweiter|ausbau/.test(label) && !/bis|up to|max|erweiter|[<>≤≥]|\d\s*[-–—/]\s*\d/.test(metric)) {
        var energy = amounts(metric, 'energy');
        if (energy.length === 1) capacities.push(energy[0]);
      }
      if (/pv.*(?:eingang|eingange|input)|(?:eingang|input).*pv/.test(label)) {
        var power = amounts(metric, 'power');
        if (power.length === 1) pvPowers.push(power[0]);
      }
      if (/kopplung|anschlussart|systemtyp|systemintegration|systemarchitektur|systemtechnologie|einbindung|anbindung|coupling|connection/.test(label)) coupling.push(metric);
      if (/montage|halterung|befestigung|aufstell/.test(label)) mount(metric);
      if (/pv.modulset|^solarmodule?$|solar.?panel|pv.set|pv.systemleistung|flexible.*pv.module|^modulanzahl$/.test(label)) {
        var count = panelCount(metric);
        if (count === null && /^modulanzahl$/.test(label) && /^\d+$/.test(metric)) count = Number(metric);
        if (count !== null) panelCounts.push(count);
      }
      if (/^(?:mikro-?)?wechselrichter(?:modell| im set| im lieferumfang)?$|^inverter(?: model)?$/.test(label) && metric && !/ohne|kein|separat|optional|empfohl|kompatib/.test(metric)) inverterIncluded = true;
      if (/^(?:mikro-?)?wechselrichter(?:modell| im set| im lieferumfang)?$|^inverter(?: model)?$/.test(label) && /ohne|kein|separat|nicht enthalten/.test(metric)) inverterExcluded = true;
      if (/lieferumfang|setinhalt/.test(label) && /wechselrichter|inverter/.test(metric) && !/ohne|kein|separat|optional/.test(metric)) inverterIncluded = true;
      if (/^(?:netzphasen|phasenzahl|phasen|netzanschluss|ac.anschluss)$/.test(label) && /dreiphas|3\s*-?\s*phas|three.?phase/.test(metric)) threePhase = true;
      if ((/^hardware$/.test(label) && /nicht enthalten|ohne|keine/.test(metric)) || (/leistungsart/.test(label) && /installation|montage|service/.test(metric))) serviceOnly = true;
      if (/modul|panel/.test(label) && /flexib|leicht|lightweight/.test(label + ' ' + metric)) lightweight = true;
      else if (/modulbauart|modultyp|panel type/.test(label) && /glas|starr|rigid/.test(metric) && lightweight !== true) lightweight = false;
    });
    optionNames.forEach(function (name, index) {
      var label = normalized(typeof name === 'object' ? name.name : name), value = normalized(optionValues[index]);
      if (/montage|halter|befestig|aufstell/.test(label)) mount(value);
      if (/wechselrichter|inverter/.test(label)) {
        if (/ohne|kein|separat/.test(value)) inverterExcluded = true;
        else if (value) inverterIncluded = true;
      }
      if (/modul|panel/.test(label)) {
        hasPanelOption = true;
        var count = panelCount(value);
        if (count !== null) panelCounts.push(count);
        if (/flexib|leicht|lightweight/.test(value)) lightweight = true;
        else if (/glas|starr|rigid/.test(value) && lightweight !== true) lightweight = false;
      }
    });
    // A fixed, single-variant kit title may substantiate quantity. A generic title
    // must not lend the same quantity to different selectable module variants.
    if (!hasPanelOption && Array.isArray(product.variants) && product.variants.length === 1 && /solarmodul|solar.?panel/.test(title)) {
      var titleCount = panelCount(title);
      if (titleCount !== null) panelCounts.push(titleCount);
    }
    if (/(?:mit|inkl\.?|inklusive).*?(?:wechselrichter|inverter)/.test(title) && !/ohne\s+(?:wechselrichter|inverter)/.test(title)) inverterIncluded = true;
    if (inverterExcluded) inverterIncluded = false;
    panelCounts = unique(panelCounts);
    var kitContext = /balkonkraftwerk|komplettset|komplettpaket|complete.?kit/.test(title + ' ' + type);
    var kitInferred = (qty === null || qty === 0) && (role === '' || role === 'panel_kit') && panelCounts.length === 1 && panelCounts[0] > 0 && kitContext && inverterIncluded;
    if (kitInferred) { qty = panelCounts[0]; role = 'panel_kit'; }
    var panelConflict = panelCounts.length > 1 || (qty !== null && panelCounts.some(function (count) { return count !== qty; }));
    var explicitAc = /\bac\b(?![\s-]*(?:ausgang|eingang|leistung|ladeeingang|output|input))/.test(title) || coupling.some(function (value) { return /\bac\b/.test(value) && !/kein|ohne|nicht/.test(value); });
    var explicitPv = coupling.some(function (value) { return /\b(?:dc|pv)\b|direkt.*solarmodul/.test(value) && !/kein|ohne|nicht/.test(value); });
    var expansionTerm = /erweiterungs(?:akku|batterie|modul)|zusatz(?:akku|batterie)|expansion.?batter|battery.?expansion/;
    var baseWithExpansion = /(?:solarbank|solarflow|hibattery|stream\s+(?:ac\s+)?\d|speichersystem|speicher|komplettset|balkonkraftwerk).*?(?:\bmit\b|\+).*?(?:zusatz|erweiterungs)/.test(title);
    var expansion = expansionTerm.test(type) || (expansionTerm.test(title) && !baseWithExpansion);
    var accessoryType = /zubehor|accessor|halterung|montagesystem|solarkabel|verlangerungskabel|adapter|smart.?meter/.test(type);
    var accessoryTitle = /(?:kabel|halterung|adapter|smart.?meter|zahler|messgerat|befestigung)/.test(title) && !/balkonkraftwerk|komplettset|solarbank|solarflow|hibattery|speicher|stromspeicher|powerstation|stream/.test(title);
    var dockOnly = /power\s*dock/.test(title) && !/solarbank|batterie|akku|speicher|solarflow|hibattery|stream/.test(title);
    serviceOnly = serviceOnly || /installationsservice|montageservice|nur installation|serviceleistung/.test(title + ' ' + type);
    var barePanels = role === 'standalone_panel' || (/^(?:pv-|solar)?module?$|^solarpanels?$|^solarmodule?$/.test(type));
    var explicitStorage = /speicher|solarbank|solarflow|hibattery|batterie|battery|powerstation/.test(title + ' ' + type);
    var scopeTitle = (title + ' ' + type).replace(/(?:3\s*-?\s*phasig\w*|dreiphasig\w*)\s+(?:smart.?meter|zahler)/g, '').replace(/(?:smart.?meter|zahler)\s+(?:3\s*-?\s*phasig\w*|dreiphasig\w*)/g, '');
    var outOfScope = /\bhaier\b/.test(title + ' ' + normalized(product.vendor)) || /dreiphas|3\s*-?\s*phas|three.?phase/.test(scopeTitle) || threePhase || /gewerbe|gewerblich|industrie|industrial|commercial|hochvolt/.test(title + ' ' + type);
    var hasPanels = (qty !== null && qty > 0) || role === 'panel_kit' || panelCounts.some(function (count) { return count > 0; });
    // A panel set with incomplete/contradictory metadata must never become a standalone battery.
    if (/solarmodul|solar.?panel/.test(title) && /set|mit|[x×]\s*\d|\d\s*[x×]/.test(title)) hasPanels = true;
    return {
      capacityKwh: capacities.length ? Math.min.apply(Math, capacities) : null,
      pvInputW: pvPowers.length ? Math.max.apply(Math, pvPowers) : null,
      panelQty: qty, panelRole: role, panelConflict: panelConflict, hasPanels: hasPanels,
      kitInferred: kitInferred, inverterIncluded: inverterIncluded, inverterExcluded: inverterExcluded, outOfScope: outOfScope,
      ac: explicitAc, pv: explicitPv || pvPowers.some(function (value) { return value > 0; }),
      lightweight: lightweight, mounting: unique(mounts), mountingSpecified: mountingSpecified,
      mountingUnspecified: mountingUnspecified || !mountingSpecified,
      expansion: expansion, accessory: accessoryType || accessoryTitle || dockOnly || serviceOnly, barePanels: barePanels,
      explicitStorage: explicitStorage
    };
  }

  function recommend(products, answers, options) {
    answers = answers || {}; options = options || {};
    var exclusions = {}, rows = [], result = { rows: rows, totalMatched: 0, exclusions: exclusions, emptyReason: null, manual: false };
    function excluded(code) { exclusions[code] = (exclusions[code] || 0) + 1; }
    if (answers.project === 'extension') {
      result.emptyReason = 'Für einen Erweiterungsakku benötigen wir die genaue Bezeichnung deines vorhandenen Speichers. Eine gleiche Marke bestätigt noch keine Kompatibilität.';
      result.manual = true; return result;
    }
    if (answers.mode !== 'bkw' && answers.mode !== 'storage') {
      result.emptyReason = 'Bitte wähle zuerst ein Balkonkraftwerk oder einen Speicher.';
      result.manual = true; return result;
    }
    if (answers.mode === 'storage' && answers.connection !== 'ac' && answers.connection !== 'pv') {
      result.emptyReason = 'Bitte kläre zuerst, ob der Speicher über AC oder direkt über die Solarmodule angeschlossen werden soll. Ohne diese Angabe können wir keine passende Einbindung bestätigen.';
      result.manual = true; return result;
    }
    var requestedPanels = ['1', '2', '4'].indexOf(String(answers.panels)) !== -1 ? Number(answers.panels) : null;
    var minimumCapacity = ['2', '5', '10'].indexOf(String(answers.capacity)) !== -1 ? Number(answers.capacity) : null;
    var location = ['balcony', 'flat', 'roof', 'wall', 'garden'].indexOf(answers.location) !== -1 ? answers.location : null;
    var wantedBrand = answers.brand && answers.brand !== 'any' ? brand(answers.brand) : null;
    (Array.isArray(products) ? products : []).forEach(function (product) {
      (Array.isArray(product.variants) ? product.variants : []).forEach(function (variant) {
        if (variant.available !== true) return excluded('unavailable');
        if (!product.handle || !variant.id) return excluded('identity');
        if (wantedBrand && brand(product.vendor) !== wantedBrand) return excluded('brand');
        var f = facts(product, variant), reasons = [], checks = [], score = 0;
        if (f.outOfScope) return excluded('outside_balcony_scope');
        if (f.expansion) return excluded('expansion');
        if (f.accessory) return excluded('accessory');
        if (f.barePanels) return excluded('bare_panels');
        if (f.panelConflict) return excluded('panel_data_conflict');
        if (answers.mode === 'bkw') {
          if (f.inverterExcluded) return excluded('inverter_not_included');
          if (f.panelRole !== 'panel_kit' || !(f.panelQty > 0)) return excluded('incomplete_kit');
          if (f.panelQty > 4) return excluded('large_pv_system');
          if (requestedPanels !== null && f.panelQty > requestedPanels) return excluded('panel_count');
          if (answers.storage === 'yes' && !(f.capacityKwh > 0)) return excluded('storage_unconfirmed');
          if (answers.storage === 'no' && ((f.capacityKwh !== null && f.capacityKwh > 0) || f.explicitStorage)) return excluded('storage_excluded');
          if (answers.lightweight === 'yes' && f.lightweight !== true) return excluded('lightweight_unconfirmed');
          if (location && f.mountingSpecified && f.mounting.indexOf(location) === -1) return excluded('mounting_mismatch');
          if (requestedPanels !== null && f.panelQty === requestedPanels) score += 100;
          else if (requestedPanels !== null) score += 50 + f.panelQty;
          reasons.push(f.panelQty + ' Solarmodul' + (f.panelQty === 1 ? '' : 'e') + ' im ausgewählten Set');
          if (answers.lightweight === 'yes') reasons.push('Flexible oder leichte Module laut Variantenangaben');
          if (location && f.mounting.indexOf(location) !== -1 && !f.mountingUnspecified) {
            score += 20; reasons.push('Montagevariante für deinen gewählten Standort');
          } else checks.push('Passende Halterung und Befestigung am Standort separat prüfen.');
          if (requestedPanels === null) checks.push('Modulanzahl und verfügbaren Platz vor dem Kauf prüfen.');
          if (answers.storage !== 'yes' && answers.storage !== 'no' && f.capacityKwh === null) checks.push('Speicherumfang dieser Variante auf der Produktseite prüfen.');
        } else {
          if (f.hasPanels) return excluded('includes_panels');
          if (!(f.capacityKwh > 0)) return excluded('capacity_unconfirmed');
        }
        if (minimumCapacity !== null && !(f.capacityKwh >= minimumCapacity)) return excluded('capacity_minimum');
        if (answers.connection === 'ac' && !f.ac) return excluded('ac_unconfirmed');
        if (answers.connection === 'pv' && !f.pv) return excluded('pv_unconfirmed');
        if (answers.connection === 'ac') reasons.push('AC-Anschluss in den Produktdaten bestätigt');
        else if (answers.connection === 'pv') reasons.push('Direkter PV-Anschluss in den Produktdaten bestätigt');
        else if (answers.mode === 'storage' || answers.storage === 'yes') checks.push('Anschlussart und Einbindung in deine bestehende Anlage vor dem Kauf klären.');
        if (f.capacityKwh > 0) reasons.push(f.capacityKwh.toLocaleString('de-DE', { maximumFractionDigits: 3 }) + ' kWh laut ausgewählter Variante');
        if (answers.project === 'retrofit') checks.push('Vorhandenen Wechselrichter, Solarmodule und Anschlussbedingungen mit dieser Variante abgleichen.');
        if (wantedBrand) reasons.push('Gewählte Marke: ' + product.vendor);
        rows.push({ product: product, variant: variant, facts: f, reasons: unique(reasons), checks: unique(checks), _score: score });
      });
    });
    function price(row) { return typeof row.variant.price === 'number' && Number.isFinite(row.variant.price) ? row.variant.price : Infinity; }
    rows.sort(function (a, b) {
      var capacityDifference = minimumCapacity !== null ? a.facts.capacityKwh - b.facts.capacityKwh : 0;
      return b._score - a._score || capacityDifference || price(a) - price(b) || String(a.product.handle).localeCompare(String(b.product.handle)) || String(a.variant.id).localeCompare(String(b.variant.id));
    });
    var seen = new Set();
    rows = rows.filter(function (row) {
      var key = row.product.id || row.product.handle;
      if (seen.has(key)) return false;
      seen.add(key); delete row._score; return true;
    });
    result.totalMatched = rows.length;
    var limit = Number.isInteger(options.limit) && options.limit > 0 ? Math.min(options.limit, 12) : 3;
    result.rows = rows.slice(0, limit);
    result.manual = result.rows.some(function (row) { return row.checks.length > 0; });
    if (!result.rows.length) {
      result.emptyReason = 'Aktuell ist keine verfügbare Variante mit ausreichend bestätigten Daten für alle Angaben vorhanden. Lass uns Anschluss, Ausstattung und Montage gemeinsam prüfen.';
      result.manual = true;
    }
    return result;
  }

  return Object.freeze({ facts: facts, recommend: recommend });
});
